var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',_vm._g(_vm._b({},'v-list-item',_vm.$attrs,false),_vm.$listeners),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v("$"+_vm._s(_vm.icon))])],1),_c('v-list-item-title',{class:_vm.titleText},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }